import { PillControl, PillControlProps } from '../pill-control';
import { Checkbox } from '../checkbox';

export const CheckPill: React.FC<PillControlProps> = ({ ...props }) => (
  <PillControl {...props}>
    <Checkbox variant="circle" {...props} />
  </PillControl>
);
